import React, { useState } from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { Card } from "@mui/material";
import { css } from "@emotion/react";
import { makeStyles } from "@mui/styles";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Bar, Chart } from "react-chartjs-2";
import { height, maxHeight } from "@mui/system";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);
const DynamicChart = ({ title, data, options, type, isOptionsEnabled }) => {
  const [viewType, setViewType] = useState("monthly"); // Monthly, quarterly, weekly
  const [dataType, setDataType] = useState("amounts"); // Amounts or Counts

  // console.log("Dynamic", title, data, options, type, isOptionsEnabled);
  const useStyles = makeStyles({
    root: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "20px",
    },
  });

  const override = css`
    display: block;
    margin: auto;
  `;
  const classes = useStyles();
  const handleViewTypeChange = (event) => {
    setViewType(event.target.value);
    // Update chart data based on the selected view type
  };

  const handleDataTypeChange = (event) => {
    setDataType(event.target.value);
    // Update chart data based on the selected data type
  };
  return (
    <Card className={classes.root}>
      <div
      // className="bg-white rounded-lg"
      // style={{
      //   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      //   padding: "1rem",
      //   marginBottom: "4rem",
      //   // height: "60%",
      //   // width: "49%",
      // }}
      >
        {isOptionsEnabled ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0.5rem",
            }}
          >
            <p className="text-xl mt-[3%]">{title}</p>
            <div
              className="claim-trends-forecast"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="options">
                <FormControl sx={{ m: 0.5, width: 120 }} size="small">
                  <Select
                    value={viewType}
                    onChange={handleViewTypeChange}
                    style={{ marginRight: "10px" }}
                  >
                    <MenuItem value="monthly">Monthly</MenuItem>
                    <MenuItem value="quarterly">Quarterly</MenuItem>
                    <MenuItem value="weekly">Weekly</MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 0.5, width: 120 }} size="small">
                  <Select value={dataType} onChange={handleDataTypeChange}>
                    <MenuItem value="amounts">Amounts</MenuItem>
                    <MenuItem value="counts">Counts</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-xl mt-[3%]">{title}</p>
        )}

        <div>
          <Chart
            type={type}
            data={data}
            options={options}
            style={{ maxHeight: isOptionsEnabled ? "270px" : null }}
          />
        </div>
      </div>
    </Card>
  );
};

export default DynamicChart;
